import { render, staticRenderFns } from "./LinkedAppointments.vue?vue&type=template&id=d7c96faa&"
import script from "./LinkedAppointments.vue?vue&type=script&lang=js&"
export * from "./LinkedAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports